import { render, staticRenderFns } from "./Dashboard-Aluno.vue?vue&type=template&id=727c8952&"
import script from "./Dashboard-Aluno.vue?vue&type=script&lang=js&"
export * from "./Dashboard-Aluno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Dashboard-Aluno.vue"
export default component.exports